import { createAction } from 'redux-actions';
import { http, noCredentials } from '../../../helpers/axios';

export const loading = createAction('@@auth/loading');

export const login = createAction('@@auth/login', ({ email, password }) => dispatch => {
  dispatch(loading());

  return noCredentials.post('/login', { email, password }).then(({ data }) => data);
});

export const me = createAction('@@auth/me', () => dispatch => {
  dispatch(loading());

  return http
    .get('/me')
    .then(({ data }) => data)
    .catch(error => {
      console.log('ERROR: ', error);
      return null;
    });
});

export const logout = createAction('@@auth/logout', () => dispatch => {
  dispatch(loading());
  return http.post('/logout');
});

export const changeGroup = createAction('@@auth/changeGroup', group => dispatch => {
  dispatch(loading());

  return http
    .put('/changeGroup', {
      group: typeof group === 'string' ? group : group._id || group.id,
    })
    .then(({ data }) => data)
    .catch(error => {
      console.log('ERROR: ', error);
      return null;
    });
});

export const clearToken = createAction('@@auth/clearToken');

export const refreshToken = createAction(
  '@@auth/refreshToken',
  () => () => http.post('/refresh').get('data')
);
